import 'whatwg-fetch';
import 'intersection-observer';

{
  // Global variables.

  // Container where new articles will be added.
  const container = document.getElementsByClassName('region-content')[0];
  // Nid of the base node.
  const { baseNid } = drupalSettings.tctmdNews;

  // Array containing the loaded node ids.
  const loadedNodes = [];

  // Keeps track of the currently visible articles.
  let visible = [];
  // Loaded articles count.
  let loadedCount = 0;

  // Ad information.
  const { adBlocks, extraAds } = drupalSettings.tctmdNews;
  const sidebarAd = adBlocks.filter(
    (item) => item.id === 'ad_block_options_desktop_sidebar_tall',
  )[0];

  // setupAds(): Refresh ad slots of dynamically loaded news articles.
  function setupAds(element) {
    // Sidebar ad.
    // Get container.
    const sidebarAdContainers = element.querySelectorAll(
      '.advertisement-aside > div',
    );
    // Iterate over available sidebar ads.
    sidebarAdContainers.forEach((item) => {
      // Check if the ad is the default ad or a custom ad.
      const adId = item.dataset.adId ? item.dataset.adId : sidebarAd.value;
      // Update id.
      item.id += `-${loadedCount}`;
      // Clear previous content.
      item.innerHTML = '';
      // Add new ad slot and display it.
      googletag.cmd.push(() => {
        googletag
          .defineSlot(
            `/14164860/${adId}`,
            [sidebarAd.size.width, sidebarAd.size.height],
            item.id,
          )
          .addService(googletag.pubads());
        googletag.display(item.id);
      });
    });
    // Footer ad.
    // Get container.
    const footerAdContainers = element.querySelectorAll('.adblock-footer');
    // Iterate over container, we may have more than one (desktop & mobile).
    footerAdContainers.forEach((item) => {
      // Check if we have a mobile or desktop ad.
      const adSize = item.classList.contains('adblock-mobile')
        ? 'mobile'
        : 'desktop';
      // Get correct ad information.
      let adConf;
      if (loadedCount === 1) adConf = extraAds.footer_2[adSize];
      else if (loadedCount === 2) adConf = extraAds.footer_3[adSize];
      else adConf = extraAds.fallback[adSize];
      // Update id.
      item.id += `-${loadedCount}`;
      item.innerHTML = '';
      // Add new ad slot and display it.
      googletag.cmd.push(() => {
        googletag
          .defineSlot(
            `/14164860/${adConf.value}`,
            [adConf.size.width, adConf.size.height],
            item.id,
          )
          .addService(googletag.pubads());
        googletag.display(item.id);
      });
    });
    // In-content ad.
    const inContentAdContainers = element.querySelectorAll(
      '.adblock-in-content',
    );
    // Iterate over containers, we may have more than one (desktop & mobile).
    inContentAdContainers.forEach((item) => {
      const { adId, adSize } = item.dataset;
      const size = adSize === 'desktop' ? [728, 90] : [350, 44];
      // Add new ad slot and display it.
      googletag.cmd.push(() => {
        googletag
          .defineSlot(`/14164860/${adId}`, size, item.id)
          .addService(googletag.pubads());
        googletag.display(item.id);
      });
    });
  }

  // fixTopContentPosition(): re-position "Top Content" block if needed, to prevent overlapping
  // with in-content ad.
  function fixTopContentPosition(element) {
    // Top Content offset height within sidebar (sidebar ad height + margins).
    // Change this if sidebar ad dimensions change.
    const sidebarAdHeight = 617;

    // In-Content ad height (Ad + Padding)
    // Change this if in-content ad dimensions change.
    const inContentAdHeight = 163;

    // Get in-content ad.
    const ad = element.querySelector('.advertisement-in-content');

    // Get Top Content block.
    const topContent = element.querySelector('.layout-sidebar .top-content');

    // Overlap of distance between in-content ad and Top Content block is less than 1rem (16px).
    if (
      topContent &&
      ad &&
      ad.offsetTop - (sidebarAdHeight + topContent.offsetHeight + 64) < 16
    ) {
      // Add extra top margin, to position Top Content block after the in-content ad.
      topContent.style.marginTop = `${
        ad.offsetTop + inContentAdHeight - sidebarAdHeight
      }px`;
    }
  }

  // trackScroll(): Registers a scroll event handler to load the next article
  // when the scroll reaches the 70% of the article container height.
  function trackScroll(element) {
    // Viewport height.
    const viewportHeight = window.innerHeight;

    // Scroll event handler function.
    const scrollHandler = () => {
      // Get position and dimensions of article.
      const boundingRect = element.getBoundingClientRect();
      // Calculate 70% of the article height.
      const loadingThreshold = Math.round(boundingRect.height * 0.7);
      // If user reaches 70% of the article height, load new article.
      if (viewportHeight - boundingRect.top > loadingThreshold) {
        // Remove event handler, it's not needed anymore.
        window.removeEventListener('scroll', scrollHandler);
        // 'showing' query parameter, containing the already loaded nids.
        const showing = loadedNodes.length
          ? `&showing=${loadedNodes.join(',')}`
          : '';
        // Fetch the new article.
        fetch(
          `/news-api/get-more-related-news/${baseNid}?_format=json${showing}`,
        )
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            // Create container for new article.
            const newArticleContainer = document.createElement('div');
            // Add content inside container.
            newArticleContainer.innerHTML = data.markup;
            // This class is needed for correct layout.
            newArticleContainer.className = 'block-system-main-block';
            // Append the new article.
            container.appendChild(newArticleContainer);
            // attach drupal behaviors.
            Drupal.attachBehaviors(newArticleContainer);
            // Find and attach scripts in the new article (Twitter embeds, etc.)
            const scripts = newArticleContainer.querySelectorAll('script');
            scripts.forEach((script) => {
              const scriptSrc = script.src;
              script.remove();
              const scriptElement = document.createElement('script');
              scriptElement.src = scriptSrc;
              scriptElement.async = true;
              document.body.appendChild(scriptElement);
            });
            // Store loaded article id.
            loadedNodes.push(data.id);
            // Save new article URL.
            newArticleContainer.dataset.url = data.url;
            // Observe intersection of loaded article.
            observer.observe(newArticleContainer); // eslint-disable-line no-use-before-define
            // Set article id.
            newArticleContainer.id = `block-tctmd-content-${++loadedCount}`; // eslint-disable-line no-plusplus
            // Mark article as new.
            newArticleContainer.dataset.isNew = true;
            // Modify print button to open a new window.
            const print = newArticleContainer.querySelector(
              '[href="javascript:window.print();"]',
            );
            if (print) {
              print.setAttribute(
                'href',
                `${window.location.pathname}?print=true`,
              );
              print.setAttribute('target', '_blank');
            }
            // Refresh ad slots in new content.
            setupAds(newArticleContainer);
            // Fix "Top Content" block position.
            fixTopContentPosition(newArticleContainer);
          });
      }
    };

    // scroll event listener.
    window.addEventListener('scroll', scrollHandler);
  }

  // setupSidebarOptionalAd(): Correctly position optional sidebar ad, if available.
  function setupSidebarOptionalAd(element) {
    // Get sidebar ads containers.
    const sidebarAds = element.querySelectorAll(
      '.layout-sidebar > .advertisement-aside',
    );
    // Check if we have an optional sidebar ad.
    if (sidebarAds.length > 1) {
      // Get individual ads.
      const optionalAd = sidebarAds[1];
      // Get optional Ad position within sidebar.
      const sidebar = document.querySelector('.layout-sidebar');
      const optionalAdTopPosition = optionalAd.offsetTop - sidebar.offsetTop;
      // Get Available space for positioning optional ad.
      const availableSpace = element.offsetHeight - optionalAdTopPosition;
      const optionalAdHeight = optionalAd.offsetHeight;
      // Determine and apply margin.
      if (availableSpace > optionalAdHeight) {
        optionalAd.style.marginTop = `${
          (availableSpace - optionalAdHeight) / 2
        }px`;
      }
      // Make ad visible.
      optionalAd.style.visibility = 'visible';
    }
  }

  // setActive(): Updates the URL and title to the currently visible article.
  function setActive(element) {
    // Replace the URL when the new article reaches the top of the screen.
    window.history.pushState({}, '', element.dataset.url);
    // Set the new title.
    const title = element.querySelector('h1.page-title span').innerHTML;
    document.title = title;
  }

  // firstPrint(): When an article is visible the first time sends a GA pageview
  // and adds the scroll tracking event to load the next article.
  function firstPrint(element) {
    // Send GA pageview.
    const tracker = ga.getAll()[0];
    tracker.set('location', window.location.href);
    tracker.set('title', document.title);
    tracker.send({ hitType: 'pageview' });
    // Send custom 'autoload' event.
    tracker.send({
      hitType: 'event',
      eventCategory: 'News',
      eventAction: 'autoload',
      eventLabel: window.location.pathname,
    });
    // Add scroll tracker.
    // trackScroll(element);
    // Refresh slot and Correctly position optional sidebar ad.
    setupSidebarOptionalAd(element);
  }

  // intersectionObserverCallback(): function called any time an article enters
  // or leaves the screen.
  function intersectionObserverCallback(entries) {
    const entry = entries[0];
    if (!entry.isIntersecting) {
      if (visible.length === 1) {
        return;
      }
      visible = visible.filter((element) => element.id !== entry.target.id);
      const element = visible[0];
      setActive(element);
      if (element.dataset.isNew === 'true') {
        element.dataset.isNew = false;
        firstPrint(element);
      }
    } else {
      visible.push(entry.target);
    }
  }

  // Create intersection Observer.
  const observer = new IntersectionObserver(intersectionObserverCallback, {
    root: null,
    rootMargin: '0px',
    threshold: 0,
  });

  // Initial article element.
  const initialArticle = document.getElementById('block-tctmd-content');

  // Store initial article URL.
  initialArticle.dataset.url = window.location.pathname;

  observer.observe(initialArticle);

  // trackScroll(initialArticle);

  // Handle print links.
  window.addEventListener('load', () => {
    if (window.location.search.indexOf('print=true') !== -1) {
      window.print();
    }
  });

  // Sidebar optional ad.
  window.addEventListener('load', () => {
    setupSidebarOptionalAd(initialArticle);
    fixTopContentPosition(initialArticle);
  });
}
